import { Drawer } from "antd";
import React from "react";
import styles from "css/mobile/mypage.module.css";
import { useTranslation } from "react-i18next";

/**
 * Version : 1.0
 * 작성일자 : 2025-02-13
 * 작성자 : 김희민
 * 설명 : 모바일 일정카드 좌측 하단 참석자자 정보 클릭시 상세팝업
 */
export default function DetailParticipantPop({
  participants,
  isOpenParticipantDetail,
  closeParticipantDetail,
}) {
  const { t } = useTranslation();
  return (
    <Drawer
      className={styles.participant_drawer}
      open={isOpenParticipantDetail}
      onClose={closeParticipantDetail}
      placement="bottom"
      mask={true}
      maskClosable={false}
      height="auto"
      title={null}
      styles={{ header: { display: "none" } }}
    >
      <div className={styles.participantContainer}>
        <div className={styles.participantHeader}>
          <h2 className={styles.participantTitle}>
            {t("LABEL.TITLE.PARTICIPANT_INFO")}
          </h2>
          <img
            src={
              process.env.REACT_APP_CLIENT_URL + "img/mobile/mypage/close.png"
            }
            alt="close"
            className={styles.participantClose}
            onClick={closeParticipantDetail}
          />
        </div>
        <div className={styles.participantContent}>
          {participants?.length === 0 && (
            <div className={styles.user}>{t("LABEL.NO_MEETING_PTCP")}</div>
          )}
          {participants?.length > 0 &&
            participants.map((participant, index) => (
              <div className={styles.user} key={index}>
                <div className={styles.userName}>{participant.MEMBER_NM}</div>
                <div className={styles.userEmail}>{participant.EMAIL}</div>
              </div>
            ))}
        </div>
      </div>
    </Drawer>
  );
}
